export * from './components/old';
export * from './container/old';
export * from './global_style';
export * from './styles';
export * from './foundation';
import { createUniqueIdentifier as createUniqueIdentifierUtils } from './utils/createUniqueIdentifier';
/**
 * @deprecated
 */
export const createUniqueIdentifier = createUniqueIdentifierUtils;
